import {
  CHANGE_AUTH,
  REST_API,
  REST_URL,
  EYM_TKN,
  EYM_TKN_OBJ,
  EYM_USR,
  GET_METHOD,
  POST_METHOD,
  PATCH_METHOD,
  DELETE_METHOD
} from "./constants";

import moment from "moment";

export function exportXML(object, token) {
  let refId = object.refId ? object.refId : null;
  let targetId = object.targetId ? object.targetId : null;
  let statusId = object.statusId ? object.statusId : null;
  let taskId = object.taskId ? object.taskId : null;
  var limit = object.limit ? object.limit : 50000;
  var date1 = object.date1;
  var date2 = object.date2;
  var userid = object.userId

  /*var isSame = moment(date1).isSame(date2)
  if(isSame){
    
    date2 = moment(date2).add(1, 'days')
    date2 = moment(date2).format("YYYY-MM-DD")
  }*/

  let fetchURL

  if (date1 && date2) {

      fetchURL = `${REST_API}/messagequeues/export?access_token=${token}&refId=${refId}&limit=${limit}&targetId=${targetId}&statusId=${statusId}&taskId=${taskId}&startDate=${date1}&endDate=${date2}&userid=${userid}`
  } else {

      fetchURL = `${REST_API}/messagequeues/export?access_token=${token}&refId=${refId}&limit=${limit}&targetId=${targetId}&statusId=${statusId}&taskId=${taskId}&userid=${userid}`
  }

  return dispatch => {
    return fetch(
      fetchURL,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
  };
}

export function exportXMLwithOptions(
  object,
  token,
  extractedOption,
  publishedOption
) {
  let refId = object.refId ? object.refId : null;
  let targetId = object.targetId ? object.targetId : null;
  let statusId = object.statusId ? object.statusId : null;
  let taskId = object.taskId ? object.taskId : null;
  var limit = object.limit ? object.limit : 50000;
  var date1 = object.date1;
  var date2 = object.date2;
  var userid = object.userId

  var isSame = moment(date1).isSame(date2)
  if(isSame){
    
    date2 = moment(date2).add(1, 'days')
    date2 = moment(date2).format("YYYY-MM-DD")
  }

  //console.log('objectobject',object.userId)
  return dispatch => {
    return fetch(
      `${REST_API}/messagequeues/export?access_token=${token}&refId=${refId}&limit=${limit}&targetId=${targetId}&statusId=${statusId}&taskId=${taskId}&extOpt=${extractedOption}&pubOpt=${publishedOption}&startDate=${date1}&endDate=${date2}&userid=${userid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/export.js